/**
 * Явный mock-режим для контрактов, которых ещё нет в production backend.
 *
 * Правило безопасности production (ТЗ «Правки Нарушения», P0-01):
 * - `REACT_APP_ANALYTICS_MOCK === 'true'` — только mock, реальный запрос не идёт;
 * - любое другое значение, включая отсутствие флага, — только реальный backend.
 *
 * Автоматической подмены 404/501 на mock здесь больше нет и быть не должно:
 * она позволяла UI показать «Зона создана» или «Права сохранены», когда
 * authoritative состояние backend не менялось вообще. Отсутствующий endpoint —
 * это контролируемая ошибка в интерфейсе, а не успех.
 */

const readFlag = () => process.env.REACT_APP_ANALYTICS_MOCK;

export const isMockForced = () => readFlag() === 'true';

/** Mock выключен везде, кроме явного mock-режима. */
export const isMockDisabled = () => !isMockForced();

export const withMockFallback = (realCall, mockCall) => {
  if (isMockForced()) return mockCall();
  return realCall();
};

/** Ошибка в форме axios: UI разбирает её тем же кодом, что и настоящую. */
export const mockHttpError = (status, data) => {
  const detail = data?.detail;
  const message = typeof detail === 'string' ? detail : detail?.code || `mock ${status}`;
  const error = new Error(message);
  error.response = { status, data };
  error.isMock = true;
  return error;
};

/** Небольшая задержка, чтобы состояния загрузки в UI были видимы и в моке. */
export const mockDelay = (value, ms = 120) =>
  new Promise((resolve) => { setTimeout(() => resolve(value), ms); });
